import React, { useContext } from 'react';

import { Grid, Skeleton, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import AdminAuthContainer from '../../../AdminAuthContainer';
import { UserContext } from '../../../UserContext';

const Spacer = styled.div`
    margin: 1rem;
`;

const PaddedSkeleton = styled(Skeleton)`
    margin: 0.5rem 0;
`;

const StyledTableHeaderCell = styled(TableCell)`
    font-weight: bolder;
    font-size: 14px;
`;

const ClassLink = styled(Link)`
    color: ${(props) => props.theme.colors.primary.main};
`;

export const UserDetailClasses = () => {
    const { userData } = useContext(UserContext);
    const { t } = useTranslation('portal');
    const { authMode } = useContainer(AdminAuthContainer);
    console.log('ClassSessionDetailInsights userData', userData, 'authMode', authMode);

    if (!userData || userData.loading) {
        return (
            <>
                <Grid container justifyContent="space-between">
                    <Grid item>
                        <Skeleton width={300} height={60} />
                    </Grid>
                    <Grid item>
                        <Skeleton width={150} height={60} />
                    </Grid>
                </Grid>
                <Spacer />
                <PaddedSkeleton height={35} />
                <PaddedSkeleton height={35} />
                <PaddedSkeleton height={35} />
                <PaddedSkeleton height={35} />
                <PaddedSkeleton height={35} />
                <Spacer />
                <Grid container justifyContent="flex-end">
                    <Skeleton width={400} height={50} />
                </Grid>
            </>
        );
    }

    return (
        <>
            <Table>
                <TableHead>
                    <TableRow>
                        <StyledTableHeaderCell>{t('class-id')}</StyledTableHeaderCell>
                        <StyledTableHeaderCell>{t('class-name')}</StyledTableHeaderCell>
                        <StyledTableHeaderCell>{t('meeting-id')}</StyledTableHeaderCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {userData.classes.map((classObj, key) => (
                        <TableRow key={key} style={{ backgroundColor: key % 2 === 0 ? '#f6f6f6' : '#fff' }}>
                            <TableCell>{classObj.sid}</TableCell>
                            <TableCell>
                                <ClassLink to={`/portal/classes/${classObj.class_uuid}`}>
                                    {classObj.class_name}
                                </ClassLink>
                            </TableCell>
                            <TableCell>{classObj.meeting_id}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </>
    );
};
